import { ProgressiveLoader } from '@driftt/tide-core-legacy'
import {
  PLACEHOLDER_PRIMARY_COLOR,
  PLACEHOLDER_SECONDARY_COLOR,
  PLACEHOLDER_PRIMARY_OPACITY,
  PLACEHOLDER_SECONDARY_OPACITY,
} from 'components/conversation/ContactSideBar'

export default () => {
  const placeholderShape = [
    <rect key={0} x="0" y="0" width="60" height="60" rx="3" />,
    <rect key={1} x="70" y="24" width="101" height="12" rx="5" />,
    <rect key={2} x="70" y="0" width="156" height="12" rx="5" />,
    <rect key={3} x="0" y="164" width="171" height="15" rx="5" />,
    <rect key={4} x="0" y="107" width="171" height="15" rx="5" />,
    <rect key={5} x="70" y="48" width="63" height="12" rx="5" />,
    <rect key={6} x="0" y="90" width="63" height="12" rx="5" />,
    <rect key={7} x="0" y="147" width="63" height="12" rx="5" />,
  ]

  const options = {
    height: 179,
    width: 226,
    primaryColor: PLACEHOLDER_PRIMARY_COLOR,
    secondaryColor: PLACEHOLDER_SECONDARY_COLOR,
    primaryOpacity: PLACEHOLDER_PRIMARY_OPACITY,
    secondaryOpacity: PLACEHOLDER_SECONDARY_OPACITY,
  }

  return <ProgressiveLoader options={options} placeholderShape={placeholderShape} numPlaceholders={1} />
}



// WEBPACK FOOTER //
// ./src/scripts/components/conversation/ContactSideBar/Company/Placeholder/index.js